
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/topBar/undoRedo/undoButton/undoTooltip/tooltip.scss.css.virtualfile';
        module.exports = {"tooltip-paragraph":"_tooltip-paragraph_u5qr0_1","tooltipParagraph":"_tooltip-paragraph_u5qr0_1"};